import getProperty from '../helpers/getProperty.js'

export default {
    getAuthPageIntro: state => state.pages.auth.intro,
    getPageBack: state => (data) => {
      console.log("🚀 ~ data:", data)
      let backPage = null;
      let statePage = getProperty(state.pages, data.state || data);

      if (data.remove && statePage.backPages.length) {
        backPage = statePage.backPages.pop();
      } else {
        backPage = statePage.backPages;
      }
      console.log("🚀 ~ backPage:", backPage)

      return backPage ? backPage : {
        name: 'home',
        path: '/'
      };
    },
    getLastPage: state => state.pages.backPage,
    getAuthPageBack: state => {
      let back = state.pages.auth.back.pop();
      return back;
    },
    getJobDistancesData: state => state.jobDistances,

    getJobCreatePageData: state => state.pages.job.create,
    getJobListingCreatePageData: state => state.pages.jobListing.create,
    getGuestShiftRecordCreatePageData: state => state.pages.guestShift.create,

    getGuestShiftDetails: state => state.pages.guestShift.details,
    getGuestShiftPublicDetails: state => state.guestShiftPublic,
    getJobShiftsBookPageData: state => state.pages.job.shifts.book,

    getJobDetails: state => state.pages.job.details,

    getJobFilters: state => state.pages.job.filters,

    getReportData: state => state.pages.report,

    getVerifyPageData: state => state.pages.verify,

    getLanguagesList: state => state.languages.list,

    // getUserRatingLeaveData: state => state.pages.rating,

    isAuthenticated: state => !!state.token,
    isActive: state => state.user.active,
    authStatus: state => state.status,
    getLoggedStatus: state => state.loggedIn,
    getAccountType: state => state.user.role,
    GET_TOKEN: state => state.token,

    // getUserData: state => state.user,
    GET_USER_DATA: state => state.user,
    GET_USER_PHONE: state => state.user.mobileNumber,
    GET_USER_EMAIL: state => state.user.email,
    GET_USER_ROLE: state => state.user.role,
    GET_USER_PLATFORM_ROLE: state => state.user.platformRole,
    GET_USER_WORK_TYPE: state => state.user.workType,


    GET_PHARMACY_SERVICES: state => state.common.pharmacy.services,
    GET_PHARMACY_SOFTWARE: state => {
      let softwareArr = [...state.common.pharmacy.software].sort((a,b)=>{
        if (a.name === 'Other' && b.name !== 'Other') {
            return 1; 
        } else if (a.name !== 'Other' && b.name === 'Other') {
            return -1;
        } else {
            return a.name.localeCompare(b.name);
        }
      })
      return softwareArr
    },
    GET_PHARMACY_SCRIPTS_COUNT: state => state.common.pharmacy.scriptsPerDay,
    GET_PHARMACY_SCRIPTS_COUNT_SATURDAY: state => state.common.pharmacy.average_scripts_saturday_id,
    GET_PHARMACY_SCRIPTS_COUNT_SUNDAY: state => state.common.pharmacy.average_scripts_sunday_id,
    GET_PHARMACY_NUMBER_OF_PATIENTS: state => state.common.pharmacy.number_of_patients,
    GET_STATES: state => state.common.states,

    GET_SHIFT_LIST: state => state.shifts,
    stripeConnectLink: state => state.stripeConnectLink,
    stripeConnectStatus: state => state.stripeConnectStatus,
    stripeRefreshLink: state => state.stripeRefreshLink,
    paymentIntent: state => state.paymentIntent,
    paymentIntentCheck: state => state.paymentIntentCheck,
    stripeLoginLink: state => state.stripeLoginLink,
    billingSession: state => state.billingSession,
    refreshJobData: state => state.refreshJobData,
    getJobPreview: state => state.jobPreview,
    getShiftApplicationDetails: state => state.shiftApplicationDetails,
    getRedirectRoute: state => state.redirectRoute,
    locumBlockedPharmacies: state => state.locumBlockedPharmacies,
    pharmacyTypes: state => state.pharmacyTypes,
    appliedCoupon: state => state.appliedCoupon,
    pharmacyAdditionalInfo: state => state.pharmacyAdditionalInfo,
}
